module.exports = __webpack_public_path__ + "static/img/KPLS.d404768.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPLS.png
// module id = BL40
// module chunks = 1